function setUpLegacySearchAutoComplete() {
  let currentAjaxRequest = null;

  const searchForms = document.querySelectorAll('form[action="/search"]');

  searchForms.forEach(form => {
    form.style.position = 'relative';

    const input = form.querySelector('input[name="q"]');
    const offsetTop = input.offsetTop + input.offsetHeight + 7;

    const resultsList = document.createElement('ul');
    resultsList.className = 'search-results search_autocomplete_wrapper';
    resultsList.style.top = offsetTop + 'px';
    resultsList.style.position = 'absolute';
    resultsList.style.display = 'none';
    form.appendChild(resultsList);

    const queryResourcesType = "product,page,article,collection&resources[limit]=4";
    const seeAllType = "type=article,product,page";

    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', () => handleInputChange(input, form, resultsList));
    input.addEventListener('change', () => handleInputChange(input, form, resultsList));

    // Close dropdown if clicking outside input or results
    document.addEventListener('click', (event) => {
      const isClickInsideInput = input.contains(event.target);
      const isClickInsideResults = resultsList.contains(event.target);
      if (!isClickInsideInput && !isClickInsideResults) {
        resultsList.style.display = 'none';
      }
    });

    function handleInputChange(inputEl, formEl, resultsEl) {
      const term = inputEl.value;
      const oldTerm = inputEl.getAttribute('data-old-term');
      const searchURL = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=${queryResourcesType}`;
      const searchURLForSeeAll = `/search?${seeAllType}&q=${encodeURIComponent(term)}`;

      if (term.length > 3 && term !== oldTerm) {
        inputEl.setAttribute('data-old-term', term);

        if (currentAjaxRequest) {
          currentAjaxRequest.abortController?.abort();
        }

        const controller = new AbortController();
        currentAjaxRequest = { abortController: controller };

        fetch(searchURL, { signal: controller.signal })
          .then(res => res.json())
          .then(data => {
            resultsEl.innerHTML = '';
            let showResults = false;
            const results = data.resources.results;

            for (const prop in results) {
              if (results[prop].length) {
                const headerItem = document.createElement('li');
                headerItem.className = 'resourses_type';
                headerItem.innerHTML = `<span>${prop.charAt(0).toUpperCase() + prop.slice(1)}</span>`;
                resultsEl.appendChild(headerItem);

                results[prop].forEach(item => {
                  if (item.tags && item.tags.includes('exclude_from_search')) {
                    return;
                  }

                  const link = document.createElement('a');
                  link.href = item.url;

                  if (prop === 'products') {
                    const thumb = document.createElement('span');
                    thumb.className = 'thumbnail';
                    thumb.innerHTML = `<img src="${item.image}" />`;
                    link.appendChild(thumb);
                  }

                  const rightWrapper = document.createElement('div');
                  rightWrapper.className = 'right_side_wrapper';
                  rightWrapper.innerHTML = `<span class="title">${item.title}</span>`;

                  if (prop === 'products') {
                    const price = Shopify.formatMoney(item.price, app.data.money_format);
                    rightWrapper.innerHTML += `<span class="money">${price}</span>`;
                  }

                  link.appendChild(rightWrapper);

                  const li = document.createElement('li');
                  li.appendChild(link);
                  resultsEl.appendChild(li);
                });

                showResults = true;
              }
            }

            if (showResults) {
              const seeAllLi = document.createElement('li');
              seeAllLi.innerHTML = `<span class="title"><a href="${searchURLForSeeAll}">See all results</a></span>`;
              resultsEl.appendChild(seeAllLi);
              resultsEl.style.display = 'block';
              resultsEl.style.opacity = '0';
              resultsEl.style.transition = 'opacity 0.2s';
              requestAnimationFrame(() => {
                resultsEl.style.opacity = '1';
              });
            } else {
              resultsEl.style.display = 'none';
            }
          })
          .catch(err => {
            if (err.name !== 'AbortError') {
              console.error('Fetch error:', err);
            }
          });
      }
    }
  });
}
